import { useCallback, useMemo, useState } from 'react';
import { useTransactionAdder } from '../state/transactions/hooks';
import { useDoUpdate, useOnchainInteractionsLendingPool } from './useOnchain';
import { ButtonState } from '../components/InteractionButton';
import useGenericCall from './useGenericCall';
import { useOffchainPoolToken } from './useOffchain';


export default function useTrackBorrows(): [ButtonState, () => Promise<void>] {
  const onchainInteractionsLendingPool = useOnchainInteractionsLendingPool();
  const symbol = useGenericCall(useOffchainPoolToken(), s => s.getSymbol());
  const doUpdate = useDoUpdate();
  const addTransaction = useTransactionAdder();
  const [pending, setPending] = useState<boolean>(false);

  const summary = `Enabled IMX reward for ${symbol}`;
  
  const trackBorrowsState: ButtonState = useMemo(() => {
    if (pending) return ButtonState.Pending;
    return ButtonState.Ready;
  }, [pending]);

  const trackBorrows = useCallback(async (): Promise<void> => {
    if (trackBorrowsState !== ButtonState.Ready) return;
    setPending(true);
    try {
      await onchainInteractionsLendingPool.trackBorrows((hash: string) => {
        addTransaction({ hash }, { summary });
      });
      doUpdate();
    }
    finally {
      setPending(false);
    }
  }, [trackBorrowsState, onchainInteractionsLendingPool, summary, addTransaction]);

  return [trackBorrowsState, trackBorrows];
}